import { useMemo } from "react";
import CustomStep2_RoundSetup from "./CustomStep2_RoundSetup";
import CustomStep2b_FocusAreas from "./CustomStep2b_FocusAreas";
import CustomStep2c_Weightage from "./CustomStep2c_Weightage";
import CustomStep2d_Requirements from "./CustomStep2d_Requirements";
import { calcMaxTopics } from "./utils/jdUtils";

const CustomStep2_RoundConfig = ({
  roundConfigSubStep,
  round,
  onDurationChange,
  jobDescription,
  jobRole,
  experienceLevel,
  currentFocus,
  onFocusChange,
  focusAreasCache,
  onFocusAreasUpdate,
  requirementsState,
  accessToken,
  allFocusAreas,
  isReadonly,
  onTopicToggle,
  onCustomTopicAdd,
  onStateUpdate,
  onStateUpdateFn,
  onWeightageChange,
  onDifficultyChange,
  onAutoDistributeWeightage,
  onSubStepNav,
}) => {
  const {
    skills,
    selectedTopics,
    suggestions,
    loadingSkills,
    error,
    customInput,
    showCustomInput,
    weightages,
    difficulties,
  } = requirementsState || {};

  // Max topics per skill derived from duration × weightage% (see jdUtils.calcMaxTopics)
  const maxTopicsPerSkill = useMemo(() => {
    if (!skills) return {};
    return skills.reduce((acc, skill) => {
      acc[skill] = calcMaxTopics(round.duration, weightages?.[skill] || 0);
      return acc;
    }, {});
  }, [skills, weightages, round.duration]);

  return (
    <>
      {roundConfigSubStep === "setup" && (
        <CustomStep2_RoundSetup
          round={round}
          onDurationChange={onDurationChange}
          onSubStepNav={onSubStepNav}
        />
      )}

      {roundConfigSubStep === "focus" && (
        <CustomStep2b_FocusAreas
          jobDescription={jobDescription}
          jobRole={jobRole}
          roundType={round.type}
          duration={round.duration}
          experienceLevel={experienceLevel}
          currentFocus={currentFocus}
          onFocusChange={onFocusChange}
          focusAreasCache={focusAreasCache}
          onFocusAreasUpdate={onFocusAreasUpdate}
          onSubStepNav={onSubStepNav}
        />
      )}

      {roundConfigSubStep === "weightage" && (
        <CustomStep2c_Weightage
          skills={skills || []}
          weightages={weightages || {}}
          difficulties={difficulties || {}}
          duration={round.duration}
          onWeightageChange={onWeightageChange}
          onDifficultyChange={onDifficultyChange}
          onAutoDistribute={onAutoDistributeWeightage}
          onSubStepNav={onSubStepNav}
        />
      )}

      {roundConfigSubStep === "requirements" && (
        <CustomStep2d_Requirements
          skills={skills}
          selectedTopics={selectedTopics}
          suggestions={suggestions}
          loadingSkills={loadingSkills}
          error={error}
          customInput={customInput}
          showCustomInput={showCustomInput}
          maxTopicsPerSkill={maxTopicsPerSkill}
          round={round}
          accessToken={accessToken}
          jobDescription={jobDescription}
          experienceLevel={experienceLevel}
          allFocusAreas={allFocusAreas}
          isReadonly={isReadonly}
          onTopicToggle={onTopicToggle}
          onCustomTopicAdd={onCustomTopicAdd}
          onStateUpdate={onStateUpdate}
          onStateUpdateFn={onStateUpdateFn}
          onSubStepNav={onSubStepNav}
        />
      )}
    </>
  );
};

export default CustomStep2_RoundConfig;
